export default "2025-06-16\n"